import { ActionTypes } from '../actions/actionTypes';

const initialState = {
  catelogViewList: [],
  totalCatelogCount: 0,
  keywordMapTitle: '',
};

export const catelogViewsReducer = (
  state = initialState,
  { type, payload }
) => {
  switch (type) {
    case ActionTypes.FETCH_CATEGLOG_VIEWS_LIST:
      const { users, totalDoc } = payload;

      return {
        ...state,
        catelogViewList: users,
        totalCatelogCount: totalDoc,
      };
    case ActionTypes.UPDATE_CATEGLOG_VIEWS_BYID_SHORTLIST:
      let clonedCateglogList = state?.catelogViewList;
      const findIndex = clonedCateglogList?.findIndex(
        (vl) => vl?._id === payload?._id
      );
      clonedCateglogList[findIndex].star = payload?.star;
      return {
        ...state,
        catelogViewList: clonedCateglogList,
      };
    case ActionTypes.SET_KEYWORD_MAPPING_TITLE:
      return {
        ...state,
        keywordMapTitle: payload,
      };

    default:
      return state;
  }
};
